const useScrollTo = ({ topOffset, behaviorType = 'smooth' })=>{
    const scrollBlock = document.querySelector('#scrollable-target');
    null == scrollBlock || scrollBlock.scrollTo({
        top: topOffset,
        behavior: behaviorType
    });
};
export { useScrollTo };
